import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import logo from './../../images/logo.png';
import { trackEvent } from '../../utils/pageMeta';

const SHOP_URL = 'https://lys-sylt.myshopify.com';

class Header extends Component {
    render() {
        return (
            <>
                <header className="site-header header mo-left header-transparent" id="fix-header">
                    <div className="sticky-header main-bar-wraper navbar-expand-lg">
                        <div className="main-bar clearfix">
                            <div className="container clearfix">

                                <div className="logo-header mostion">
                                    <Link to={'./'} className="dez-page"><img src={logo} alt="Rumours Media Logo" /></Link>
                                </div>

                                <div className="extra-nav">
                                    <div className="extra-cell">
                                        <a
                                            href={SHOP_URL}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="site-button-link"
                                            onClick={() => trackEvent('click_shop_partner', { partner: 'lys-sylt', location: 'header' })}
                                        >
                                            Shop
                                        </a>
                                    </div>
                                    <div className="extra-cell">
                                        <Link to={'./contact'} className="dez-page site-button primary">Kontakt</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
            </>
        )
    }
}
export default Header;
